/**
 * Homepage header logo animation.
 * Only runs when [data-header-logo-animation-enabled].
 */
(function () {
  'use strict';

  var MOBILE_BP = 900;

 function readHeroScale(wrapper, isMobile) {
  var attr = isMobile
    ? wrapper.getAttribute('data-hero-logo-scale-mobile')
    : wrapper.getAttribute('data-hero-logo-scale');
  if (attr == null || attr === '') {
    attr = wrapper.getAttribute('data-hero-logo-scale');
  }
  var n = parseFloat(attr);
  return Number.isFinite(n) && n >= 1 ? n : (isMobile ? 6 : 3.5);
}

  function getFirstSection() {
    return (
      document.querySelector('.main-content > .shopify-section:first-child') ||
      document.querySelector('.main-content .shopify-section.section-overlay-header')
    );
  }

  function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function getSectionAbsBottom(section) {
    if (!section) return window.innerHeight;
    var scrollY = window.scrollY || window.pageYOffset;
    return section.getBoundingClientRect().bottom + scrollY;
  }

  /* ────────────────────────────────────────────
   *  Desktop
   * ──────────────────────────────────────────── */

 function runDesktop(wrapper) {
    var slotEl = wrapper.querySelector('.header__desktop [data-header-logo-animation]');
    var inner = slotEl && slotEl.querySelector('[data-header-logo-animation-inner]');
    var themeHeader = wrapper.querySelector('.theme__header');
    if (!slotEl || !inner) return;

    var HOLD_VH            = 0.4; // scroll fraction before animation starts
    var ANIM_VH            = 0.5; // scroll fraction over which animation runs
    var FADE_START         = 0.1; // progress point where logo cross-fade begins
    var INNER_FADE_START   = 0.6; // progress when header slot logo starts fading in
    var COLOR_SWAP_START   = 0.3; // clone turns black earlier
    var NAV_SLIDE_START    = 0.45; // progress when nav slides in and is-in-header is applied
    var ANCHOR_X           = 16; // px from left edge
    var ANCHOR_BOTTOM      = 20; // px from bottom of viewport (fixed mode)
    var LOGO_BOTTOM_OFFSET = 40; // px the hero sits above its anchor line

    var heroScale = readHeroScale(wrapper, false);

    var barC = wrapper.querySelector('.header__desktop__bar__c');
    var navEls = [barC].filter(Boolean);
    navEls.forEach(function (el) {
      el.addEventListener('animationend', function () {
        el.classList.remove('nav-slide-in', 'nav-slide-out');
      });
    });

    var heroClone = inner.cloneNode(true);
    heroClone.removeAttribute('data-header-logo-animation-inner');
    heroClone.setAttribute('data-header-logo-animation-clone', '');

    var cloneColorLogo = heroClone.querySelector('.logo__img--color');
    var cloneTransLogo = heroClone.querySelector('.logo__img--transparent');

    if (cloneColorLogo) cloneColorLogo.style.opacity = '0';
    if (cloneTransLogo) cloneTransLogo.style.opacity = '1';

    var logoLink = inner.querySelector('.header__logo__link');
    var logoWidth = logoLink
      ? (parseInt(getComputedStyle(logoLink).getPropertyValue('--logo-width-desktop'), 10) || 120)
      : 120;

    var cloneLogoLink = heroClone.querySelector('.header__logo__link');
    var heroLogoWidth = Math.ceil(logoWidth * heroScale);
    if (cloneLogoLink) {
      cloneLogoLink.style.setProperty('--logo-width-desktop', heroLogoWidth + 'px');
      cloneLogoLink.style.width = heroLogoWidth + 'px';
    }

    var heroSize = heroLogoWidth;
    heroClone.querySelectorAll('img').forEach(function (img) {
      img.sizes = heroSize + 'px';
    });

    inner.style.opacity    = '0';
    inner.style.visibility = 'hidden';

    document.body.appendChild(heroClone);
    heroClone.style.transformOrigin = 'bottom left';
    heroClone.style.willChange      = 'transform, opacity';
    heroClone.style.transition      = 'none';
    heroClone.style.zIndex          = '5000';

    var wasInHeader  = false;
    var wasAnimating = false;
    var prevRawProgress = 0;
    var firstSection = getFirstSection();
    var sectionAbsBottom = 0;
    var cloneNaturalH    = 0;
    var destVPLeft       = 0;
    var destVPTop        = 0;
    var rAFId = null;
    var headerScale = 1 / heroScale;

    function remeasure() {
      if (!firstSection) firstSection = getFirstSection();
      sectionAbsBottom = getSectionAbsBottom(firstSection);
      cloneNaturalH   = heroClone.offsetHeight;
      var slotRect     = slotEl.getBoundingClientRect();
      destVPLeft       = slotRect.left;
      destVPTop        = slotRect.top;
    }

    function placeHero() {
      heroClone.style.position  = 'absolute';
      heroClone.style.top       = (sectionAbsBottom - LOGO_BOTTOM_OFFSET - cloneNaturalH) + 'px';
      heroClone.style.bottom    = 'auto';
      heroClone.style.left      = ANCHOR_X + 'px';
      heroClone.style.transform = 'scale(1)';
      heroClone.style.zIndex    = '5000';
    }

    function tick() {
      rAFId = null;

      var scrollY = window.scrollY || window.pageYOffset;
      var vh      = window.innerHeight;
      var holdEnd = vh * HOLD_VH;
      var animLen = vh * ANIM_VH;

      var rawProgress = scrollY <= holdEnd
        ? 0
        : clamp((scrollY - holdEnd) / animLen, 0, 1);
      var progress = rawProgress > 0 && rawProgress < 1
        ? easeOutCubic(rawProgress)
        : rawProgress;

      // ── Hold phase ──
      if (progress === 0) {
        if (wasAnimating) {
          inner.style.opacity    = '0';
          inner.style.visibility = 'hidden';
          if (cloneColorLogo) cloneColorLogo.style.opacity = '0';
          if (cloneTransLogo) cloneTransLogo.style.opacity = '1';
          if (themeHeader) themeHeader.style.setProperty('--header-bg-opacity', '0');
          if (wasInHeader) {
            slotEl.classList.remove('is-in-header');
            navEls.forEach(function (el) {
              el.classList.remove('nav-slide-in');
              el.classList.add('nav-slide-out');
            });
            wasInHeader = false;
          }
        }
        heroClone.style.opacity       = '1';
        heroClone.style.visibility    = 'visible';
        heroClone.style.pointerEvents = '';
        heroClone.style.cursor        = 'default';
        heroClone.style.pointerEvents = 'none';
        placeHero();
        wasAnimating = false;
        prevRawProgress = rawProgress;
        remeasure();
        return;
      }

      // ── Animation phase ──
      if (!wasAnimating) {
        heroClone.style.position = 'fixed';
        heroClone.style.top      = 'auto';
        heroClone.style.bottom   = ANCHOR_BOTTOM + 'px';
        heroClone.style.left     = ANCHOR_X + 'px';
        var slotRectStart = slotEl.getBoundingClientRect();
        destVPLeft = slotRectStart.left;
        destVPTop  = slotRectStart.top;

      }

      // Target the logo postion in the header
      var anchorBottomVP  = vh - ANCHOR_BOTTOM;
      var sectionBottomVP = Math.min(sectionAbsBottom - scrollY, vh);
      var startTy = (sectionBottomVP - LOGO_BOTTOM_OFFSET) - anchorBottomVP;

      var currentScale = 1 + (headerScale - 1) * progress;

      var endTx        = (destVPLeft - ANCHOR_X) + 15;

      var cloneScaledH = cloneNaturalH * headerScale;
      var cachedEndTy = (destVPTop + cloneScaledH) - anchorBottomVP + 15;
      var endTy;
      if (rawProgress < NAV_SLIDE_START) {
        endTy = cachedEndTy;
      } else {
        var liveSlotTop = slotEl.getBoundingClientRect().top;
        var liveEndTy   = (liveSlotTop + cloneScaledH) - anchorBottomVP;
        var blendP = clamp((rawProgress - NAV_SLIDE_START) / (1 - NAV_SLIDE_START), 0, 1);
        endTy = cachedEndTy + (liveEndTy - cachedEndTy) * blendP;
      }

      var inHeader = rawProgress >= NAV_SLIDE_START;



      if (inHeader !== wasInHeader) {
        slotEl.classList.toggle('is-in-header', inHeader);
        navEls.forEach(function (el) {
          if (inHeader) {
            el.classList.remove('nav-slide-out');
            el.classList.add('nav-slide-in');
          } else {
            el.classList.remove('nav-slide-in');
            el.classList.add('nav-slide-out');
          }
        });
        wasInHeader = inHeader;
      }


      if (rawProgress >= 1) {
        heroClone.style.opacity       = '0';
        heroClone.style.pointerEvents = 'none';
        heroClone.style.visibility    = 'hidden';
        inner.style.transition = 'none';
        inner.style.opacity    = '1';
        inner.style.visibility = 'visible';
      } else if (rawProgress >= INNER_FADE_START) {
        var innerFadeP = clamp((rawProgress - INNER_FADE_START) / (1 - INNER_FADE_START), 0, 1);
        inner.style.transition  = 'none';
        inner.style.opacity     = String(innerFadeP);
        inner.style.visibility  = 'visible';

        heroClone.style.visibility    = 'visible';
        heroClone.style.pointerEvents = '';
        heroClone.style.top           = 'auto';
        heroClone.style.bottom        = ANCHOR_BOTTOM + 'px';
        heroClone.style.transform     = 'translate3d(' +
          (endTx * progress) + 'px,' +
          (startTy + (endTy - startTy) * progress) + 'px,' +
          '0) scale(' + currentScale + ')';

        var colorP = rawProgress < COLOR_SWAP_START
          ? 0 : clamp((rawProgress - COLOR_SWAP_START) / (FADE_START - COLOR_SWAP_START), 0, 1);
        if (cloneColorLogo) cloneColorLogo.style.opacity = String(colorP);
        if (cloneTransLogo) cloneTransLogo.style.opacity = String(1 - colorP);

        var fadeP = rawProgress < FADE_START
          ? 0 : clamp((rawProgress - FADE_START) / (1 - FADE_START), 0, 1);
        heroClone.style.opacity = String(1 - fadeP);
      } else {
        inner.style.transition = 'none';
        inner.style.opacity    = '0';
        inner.style.visibility = 'hidden';

        heroClone.style.visibility    = 'visible';
        heroClone.style.pointerEvents = '';
        heroClone.style.top           = 'auto';
        heroClone.style.bottom        = ANCHOR_BOTTOM + 'px';
        heroClone.style.transform     = 'translate3d(' +
          (endTx * progress) + 'px,' +
          (startTy + (endTy - startTy) * progress) + 'px,' +
          '0) scale(' + currentScale + ')';

        var colorP = rawProgress < COLOR_SWAP_START
          ? 0 : clamp((rawProgress - COLOR_SWAP_START) / (FADE_START - COLOR_SWAP_START), 0, 1);
        if (cloneColorLogo) cloneColorLogo.style.opacity = String(colorP);
        if (cloneTransLogo) cloneTransLogo.style.opacity = String(1 - colorP);

        var fadeP = rawProgress < FADE_START
          ? 0 : clamp((rawProgress - FADE_START) / (1 - FADE_START), 0, 1);
        heroClone.style.opacity = String(1 - fadeP);
      }

      var swapped = rawProgress >= FADE_START;
      slotEl.style.setProperty('--logo-color-opacity', swapped ? '1' : '0');
      slotEl.style.setProperty('--logo-transparent-opacity', swapped ? '0' : '1');

      if (themeHeader) {
        themeHeader.style.setProperty('--header-bg-opacity', String(progress));
      }

      wasAnimating = true;
      prevRawProgress = rawProgress;
      if (rawProgress < 1) rAFId = requestAnimationFrame(tick);
    }

    function scheduleFrame() {
      if (rAFId === null) rAFId = requestAnimationFrame(tick);
    }

    function reveal() {
      remeasure();
      placeHero();
      heroClone.style.opacity = '1';
    }

    remeasure();
    placeHero();

    var imgArr = Array.prototype.slice.call(heroClone.querySelectorAll('img'));
    var decodes = imgArr.map(function (img) {
      return typeof img.decode === 'function' ? img.decode().catch(function () {}) : Promise.resolve();
    });
    Promise.all(decodes).then(reveal);
    setTimeout(reveal, 2500);

    document.addEventListener('scroll', scheduleFrame, { passive: true });

    window.addEventListener('resize', function () {
      remeasure();
      if (!wasAnimating) placeHero();
      scheduleFrame();
    });
    window.addEventListener('orientationchange', function () {
      remeasure();
      if (!wasAnimating) placeHero();
      scheduleFrame();
    });

    if (firstSection && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        remeasure();
        if (!wasAnimating) placeHero();
      }).observe(firstSection);
    }

    window.addEventListener('load', function () {
      remeasure();
      if (!wasAnimating) placeHero();
      requestAnimationFrame(tick);
    });
  }



/* ────────────────────────────────────────────
*  Mobile
* ──────────────────────────────── */

  function runMobile(wrapper) {
    var heroEl   = wrapper.querySelector('[data-header-logo-hero-mobile]');
    var headerLogo = wrapper.querySelector('.header__mobile .header__logo');
    var themeHeader = wrapper.querySelector('.theme__header');
    if (!heroEl || !headerLogo) return;

    var HOLD_VH     = 0.4;   // scroll fraction before animation starts
    var ANIM_VH     = 0.6;   // scroll fraction over which animation runs
    var FADE_START  = 0.7;  // progress point where logo cross-fade begins
    var ANCHOR_X    = 16;    // px from left edge
    var ANCHOR_BOTTOM = 20;  // px from bottom of viewport (fixed mode)
    var LOGO_BOTTOM_OFFSET = 40; // px the hero sits above its anchor line

    var heroScale = readHeroScale(wrapper, true);

    headerLogo.style.opacity = '0';
    document.body.appendChild(heroEl);

    heroEl.style.willChange      = 'transform, opacity';
    heroEl.style.transition      = 'none';
    heroEl.style.transformOrigin = 'bottom left';

    var colorLogo = heroEl.querySelector('.logo__img--color');
    var transLogo = heroEl.querySelector('.logo__img--transparent');
    var logoLink  = heroEl.querySelector('.header__logo__link');

    if (logoLink) {
      var logoWidth = parseInt(getComputedStyle(logoLink).getPropertyValue('--logo-width-mobile'), 10) || 100;
      var heroSize  = Math.ceil(logoWidth * heroScale);
      heroEl.querySelectorAll('img').forEach(function (img) { img.sizes = heroSize + 'px'; });
    }

    var rAFId        = null;
    var wasAnimating = false;

    var heroNaturalH   = 0;
    var sectionAbsBottom = 0;
    var destVPLeft     = 0;
    var destVPBottom   = 0;
    var firstSection   = getFirstSection();

    function remeasure() {
      if (!firstSection) firstSection = getFirstSection();
      sectionAbsBottom = getSectionAbsBottom(firstSection);
      heroNaturalH     = heroEl.offsetHeight;
      var destRect     = headerLogo.getBoundingClientRect();
      destVPLeft       = destRect.left;
      destVPBottom     = destRect.top + destRect.height;
    }

  // Hold phase
    function placeAbsolute() {
      heroEl.style.position  = 'absolute';
      heroEl.style.bottom    = 'auto';
      heroEl.style.left      = ANCHOR_X + 'px';
      heroEl.style.top       = (sectionAbsBottom - LOGO_BOTTOM_OFFSET - heroNaturalH) + 'px';
      heroEl.style.transform = 'scale(' + heroScale + ')';
    }

    function tick() {
    rAFId = null;

    var scrollY  = window.scrollY || window.pageYOffset;
    var vh       = window.innerHeight;
    var holdEnd  = vh * HOLD_VH;
    var animLen  = vh * ANIM_VH;

    var rawProgress = scrollY <= holdEnd ? 0
      : clamp((scrollY - holdEnd) / animLen, 0, 1);
    var progress = (rawProgress > 0 && rawProgress < 1)
      ? easeOutCubic(rawProgress) : rawProgress;

    if (progress === 0) {
      if (wasAnimating) {
        heroEl.style.opacity       = '1';
        heroEl.style.pointerEvents = '';
        heroEl.style.visibility    = 'visible';
        headerLogo.style.opacity   = '0';
        if (colorLogo) colorLogo.style.opacity = '0';
        if (transLogo) transLogo.style.opacity = '1';
        if (themeHeader) themeHeader.style.setProperty('--header-bg-opacity', '0');
      }
      placeAbsolute();
      wasAnimating = false;
      return;
    }

    // Animation phase
    if (!wasAnimating) {
      heroEl.style.position   = 'fixed';
      heroEl.style.top        = 'auto';
      heroEl.style.bottom     = ANCHOR_BOTTOM + 'px';
      heroEl.style.left       = ANCHOR_X + 'px';
    }

    var anchorBottomVP = vh - ANCHOR_BOTTOM;
    var sectionBottomVP = Math.min(sectionAbsBottom - scrollY, vh);
    var startTy = (sectionBottomVP - LOGO_BOTTOM_OFFSET) - anchorBottomVP;

    heroEl.style.transform = 'translate3d(' +
      ((destVPLeft - ANCHOR_X) * progress) + 'px,' +
      (startTy + (destVPBottom - anchorBottomVP - startTy) * progress) + 'px,' +
      '0) scale(' + (heroScale + (1 - heroScale) * progress) + ')';

    // Logo fade-in animation into header
    if (rawProgress >= 1) {
      heroEl.style.opacity       = '0';
      heroEl.style.pointerEvents = 'none';
      heroEl.style.visibility    = 'hidden';
      headerLogo.style.opacity   = '1';
    } else {
      heroEl.style.visibility    = 'visible';
      heroEl.style.pointerEvents = '';
      var fadeP = rawProgress < FADE_START
        ? 0 : clamp((rawProgress - FADE_START) / (1 - FADE_START), 0, 1);
      heroEl.style.opacity     = String(1 - fadeP);
      headerLogo.style.opacity = String(fadeP);
      var swapped = rawProgress >= FADE_START;
      if (colorLogo) colorLogo.style.opacity = swapped ? '1' : '0';
      if (transLogo) transLogo.style.opacity = swapped ? '0' : '1';
    }

    if (themeHeader) themeHeader.style.setProperty('--header-bg-opacity', String(progress));

    wasAnimating = true;
    if (rawProgress < 1) rAFId = requestAnimationFrame(tick);
  }


    function scheduleFrame() {
      if (rAFId === null) rAFId = requestAnimationFrame(tick);
    }

    // Hamburger menu toggle handling 
    var hamburger = wrapper.querySelector('.header__mobile__hamburger');
    if (hamburger) {
      new MutationObserver(function () {
        var open = hamburger.getAttribute('aria-expanded') === 'true';
        if (open) {
          heroEl.style.opacity     = '0';
          headerLogo.style.opacity = '1';
        } else {
          scheduleFrame();
        }
      }).observe(hamburger, { attributes: true, attributeFilter: ['aria-expanded'] });
    }

    function reveal() {
      remeasure();
      placeAbsolute();
      heroEl.style.opacity = '1';
    }

    remeasure();
    placeAbsolute();

    var decodes = Array.prototype.slice.call(heroEl.querySelectorAll('img')).map(function (img) {
      return typeof img.decode === 'function' ? img.decode().catch(function () {}) : Promise.resolve();
    });
    Promise.all(decodes).then(reveal);

    document.addEventListener('scroll', scheduleFrame, { passive: true });

    window.addEventListener('resize', function () {
      remeasure();
      if (!wasAnimating) placeAbsolute();
      scheduleFrame();
    });

    window.addEventListener('orientationchange', function () {
      remeasure();
      if (!wasAnimating) placeAbsolute();
      scheduleFrame();
    });

    window.addEventListener('load', function () {
      remeasure();
      if (!wasAnimating) placeAbsolute();
      requestAnimationFrame(tick);
    });

    if (firstSection && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        remeasure();
        if (!wasAnimating) placeAbsolute();
      }).observe(firstSection);
    }
  }
  /* ────────────────────────────────────────────
   *  Entry
   * ──────────────────────────────────────────── */

  function resetDesktopAnimation(wrapper) {
    if (!wrapper) return;
    var inner = wrapper.querySelector('[data-header-logo-animation-inner]');
    if (inner) {
      inner.style.opacity = '';
      inner.style.visibility = '';
    }
    var clone = document.querySelector('[data-header-logo-animation-clone]');
    if (clone) clone.remove();
  }

  function resetMobileAnimation(wrapper) {
    if (!wrapper) return;
    var heroEl = document.querySelector('.header__logo-hero-mobile');
    if (heroEl) {
      heroEl.style.opacity = '0';
      heroEl.style.position = '';
      heroEl.style.transform = '';
    }
    var headerLogo = wrapper.querySelector('.header__mobile .header__logo');
    if (headerLogo) headerLogo.style.opacity = '';
  }

function run() {
  var wrapper = document.querySelector('[data-header-logo-animation-enabled]');
  if (!wrapper) return;

  var desktopEnabled = wrapper.hasAttribute('data-logo-animation-desktop');
  var mobileEnabled  = wrapper.hasAttribute('data-logo-animation-mobile');
  var isMobile = window.innerWidth < MOBILE_BP;

  if (isMobile) {
    if (mobileEnabled) {
      runMobile(wrapper);
    } else {
      resetMobileAnimation(wrapper);
    }
  } else {
    if (desktopEnabled) {
      runDesktop(wrapper);
    } else {
      resetDesktopAnimation(wrapper);
    }
  }
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Re-initialize on Shopify Theme Editor section reload */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-section-type="header"]')) {
      resetDesktopAnimation(e.target.querySelector('[data-header-logo-animation-enabled]'));
      resetMobileAnimation(e.target.querySelector('[data-header-logo-animation-enabled]'));
      run();
    }
  });
})();

